import * as actionTypes from './../Register_action.types';
import * as api from './../register_api_services/Tn_form_VI.api';

export const getTn_form_VIRequest = () => ({
  type: actionTypes.GET_TN_FORM_VI_REQUEST,
});

export const getTn_form_VISuccess = (holidays) => ({
  type: actionTypes.GET_TN_FORM_VI_SUCCESS,
  payload: holidays,
});

export const getTn_form_VIFailure = (error) => ({
  type: actionTypes.GET_TN_FORM_VI_FAILURE,
  payload: error,
});

export const getTn_form_VI = (year) => {
  console.log("Fetching holidays for year:", year);  // Fixed typo in the console log

  return async (dispatch) => {
    dispatch(getTn_form_VIRequest(year));
    try {
      const holidays = await api.fetchTn_form_VIData(year);  // Call the API function
      dispatch(getTn_form_VISuccess(holidays));
      return { success: true, data: holidays };
    } catch (error) {
      dispatch(getTn_form_VIFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateTn_form_VIRequest = (id, holidaysData) => ({
  type: actionTypes.UPDATE_TN_FORM_VI_REQUEST,
  payload: { id, holidaysData },
});

export const updateTn_form_VISuccess = (message) => ({
  type: actionTypes.UPDATE_TN_FORM_VI_SUCCESS,
  payload: message,
});

export const updateTn_form_VIFailure = (error) => ({
  type: actionTypes.UPDATE_TN_FORM_VI_FAILURE,
  payload: error,
});

// Function to handle holiday updates
export const updateTn_form_VIById = (id, holidaysData) => {
  return async (dispatch) => {
    const user = JSON.parse(sessionStorage.getItem('user'));
    holidaysData.updated_by = user.user_name;

    dispatch(updateTn_form_VIRequest(id, holidaysData));
    try {
      const response = await api.updateTn_form_VI(id, holidaysData);
      dispatch(updateTn_form_VISuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Error updating holiday';
      dispatch(updateTn_form_VIFailure(errorMessage));
      return { success: false, message: errorMessage };
    }
  };
};


export const deleteTn_form_VIRequest = (id) => ({
  type: actionTypes.DELETE_TN_FORM_VI_REQUEST,
  payload: id,
});

export const deleteTn_form_VISuccess = (message) => ({
  type: actionTypes.DELETE_TN_FORM_VI_SUCCESS,
  payload: message,
});

export const deleteTn_form_VIFailure = (error) => ({
  type: actionTypes.DELETE_TN_FORM_VI_FAILURE,
  payload: error,
});

export const deleteTn_form_VIById = (id) => {
  return async (dispatch) => {
    dispatch(deleteTn_form_VIRequest(id));
    try {
      const response = await api.deleteTn_form_VI(id);
      dispatch(deleteTn_form_VISuccess(response.message));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(deleteTn_form_VIFailure(error));
      return { success: false, message: error };
    }
  };
};



export const uploadTn_form_VIRequest = (fileData) => ({
  type: actionTypes.UPLOAD_TN_FORM_VI_REQUEST,
  payload: fileData,
});

export const uploadTn_form_VISuccess = (message) => ({
  type: actionTypes.UPLOAD_TN_FORM_VI_SUCCESS,
  payload: message,
});

export const uploadTn_form_VIFailure = (error) => ({
  type: actionTypes.UPLOAD_TN_FORM_VI_FAILURE,
  payload: error,
});

export const uploadTn_form_VIFile = (fileData) => {
  return async (dispatch) => {
    dispatch(uploadTn_form_VIRequest(fileData));
    try {
      const response = await api.Tn_form_VIUpload(fileData);
      dispatch(uploadTn_form_VISuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(uploadTn_form_VIFailure(error));
      const errorMessage = error?.response?.data?.error || error?.message || 'Upload failed';
      return { success: false, error: errorMessage };
    }
  };
};


export const multiDaleteTn_form_VIRequest = (ids) => ({
  type: actionTypes.MULTIDELETE_TN_FORM_VI_REQUEST,
  payload: ids,
});

export const multiDaleteTn_form_VISuccess = (message) => ({
  type: actionTypes.MULTIDELETE_TN_FORM_VI_SUCCESS,
  payload: message,
});

export const multiDaleteTn_form_VIFailure = (error) => ({
  type: actionTypes.MULTIDELETE_TN_FORM_VI_FAILURE,
  payload: error,
});

export const multiDeleteTn_form_VI = (ids) => {
  return async (dispatch) => {
    dispatch(multiDaleteTn_form_VIRequest(ids));
    try {
      const response = await api.multiDeleteTn_form_VI(ids);
      dispatch(multiDaleteTn_form_VISuccess(response));
      return { success: true, message: response };
    } catch (error) {
      dispatch(multiDaleteTn_form_VIFailure(error));
      return { success: false, message: error };
    }
  };
};


